import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';
import { AbstractHttpService } from '../base/abstract.http.service';
import { DOCUMENT } from '../base/service-const';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends AbstractHttpService<any> {

  enabledButton: boolean = true;

  constructor(
    protected _httpClient: HttpClient,
    private appConfigService: AppConfigService
  ) {
    super(_httpClient, DOCUMENT, appConfigService.apiBaseUrl);
  }

  public getBankSlip(orderId: number): Observable<any> {
    return this.customRead(`boleto/${orderId}`);
  }

  public getIncomePDF(orderId: number): Observable<any> {
    return this.customRead(`pdf/${orderId}`);
  }

  public getIncomeXML(orderId: number): Observable<any> {
    return this.customRead(`xml/${orderId}`);
  }
}
